// extracted by mini-css-extract-plugin
module.exports = {"TopicsPage":"page_TopicsPage__xqvnw","sidebar":"page_sidebar__1IuDL","inactive":"page_inactive__2zjlQ","body":"page_body__3korB","questions":"page_questions__2iWze"};